import { del, get, patch, post, Request, Response } from '@/api'
import { PageableResponse } from '@/types'
import {
  AddToCartSuccess,
  CollectionId,
  CollectionItemPatchDto,
  CollectionItemPostDto,
  CollectionName,
  CollectionPatchDto,
  DetailedShopCollection,
  EmailPreview,
  FilterIdentifier,
  SendCollectionPostDto,
  ShopCollection,
  StorefrontCollectionSort
} from '@/types/index'

export default {
  getCollections: (
    page: number,
    size: number,
    sort: StorefrontCollectionSort,
    filter?: string,
    search?: string
  ): Promise<Response<PageableResponse<ShopCollection>>> => {
    const config: Request = {
      params: {
        search,
        page: page - 1,
        size,
        sort,
        filter
      }
    }
    return get<PageableResponse<ShopCollection>>('/collections', config)
  },
  getCollectionsFilters: (
    filter?: string,
    search?: string
  ): Promise<Response<FilterIdentifier[]>> => {
    const config: Request = {
      params: {
        search,
        filter
      }
    }

    return get<FilterIdentifier[]>('/collections/filters', config)
  },
  getCollection: (collectionId: string): Promise<Response<DetailedShopCollection>> => {
    return get<DetailedShopCollection>('/collections/' + collectionId)
  },
  createCollection: (collectionName: CollectionName): Promise<Response<string>> => {
    return post<string, CollectionName>('/collections', collectionName)
  },
  addToCollection: (
    collectionId: string,
    collectionItemPostDTO: CollectionItemPostDto
  ): Promise<Response<string>> => {
    return post<string, CollectionItemPostDto>(
      '/collections/' + collectionId,
      collectionItemPostDTO
    )
  },
  updateCollection: (
    collectionId: string,
    collectionPatch: CollectionPatchDto
  ): Promise<Response<string>> => {
    return patch<string, CollectionPatchDto>('/collections/' + collectionId, collectionPatch)
  },
  updateCollectionItem: (
    collectionId: string,
    productId: number,
    collectionItemPatch: CollectionItemPatchDto
  ): Promise<Response<string>> => {
    return patch<string, CollectionItemPatchDto>(
      '/collections/' + collectionId + '/items/' + productId,
      collectionItemPatch
    )
  },
  deleteCollectionItem: (collectionId: string, productId: number): Promise<Response<string>> => {
    return del<string>('/collections/' + collectionId + '/items/' + productId)
  },
  deleteCollection: (collectionId: string): Promise<Response<string>> => {
    return del<string>('/collections/' + collectionId)
  },
  getEmailPreview: (id: string): Promise<Response<EmailPreview>> => {
    return get<EmailPreview>('/emails/send-collection/' + id)
  },
  sendEmail: (id: string, dto: SendCollectionPostDto): Promise<Response<string>> => {
    return post<string, SendCollectionPostDto>('/emails/send-collection/' + id, dto)
  },
  addCollectionToCart: (id: string): Promise<Response<AddToCartSuccess>> => {
    return post<AddToCartSuccess, CollectionId>('/collections/actions/to-cart', {
      id: id
    })
  },
  createQuoteRequest: (id: string): Promise<Response<string>> => {
    return post<string, CollectionId>('/collections/actions/request-quote', {
      id: id
    })
  },
  archiveCollection: (id: string): Promise<Response<string>> => {
    return post<string, CollectionId>('/collections/actions/archive', {
      id: id
    })
  },
  dearchiveCollection: (id: string): Promise<Response<string>> => {
    return post<string, CollectionId>('/collections/actions/dearchive', {
      id: id
    })
  },
  duplicateCollection: (id: string): Promise<Response<string>> => {
    return post<string, CollectionId>('/collections/actions/duplicate', {
      id: id
    })
  }
}
